/**
=========================================================
* ooGoal - v5.0.0
=========================================================

* Product Page: https://oogoal.com
* Copyright 2022 Onza Technologies

=========================================================

* The above copyright must be included
*/

import Zoom from "@mui/material/Zoom";
import colors from "assets/theme/theme-dark/base/colors";
import typography from "assets/theme/theme-dark/base/typography";
import borders from "assets/theme/theme-dark/base/borders";
import pxToRem from "assets/theme/functions/pxToRem";

const { black, white } = colors;
const { size, fontWeightLighter } = typography;
const { borderRadius } = borders;

const tooltip = {
  defaultProps: {
    arrow: true,
    TransitionComponent: Zoom,
  },

  styleOverrides: {
    tooltip: {
      maxWidth: pxToRem(200),
      backgroundColor: white.main,
      color: black.main,
      fontSize: size.xs,
      fontWeight: fontWeightLighter,
      textAlign: "center",
      borderRadius: borderRadius.sm,
      opacity: 1,
    },

    arrow: {
      color: white.main,
    },
  },
};

export default tooltip;
